import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminLogin.css";

// Configurare API URL bazată pe environment
const getApiUrl = () => {
  // Dacă ești în producție (aplicația este deployed)
  if (process.env.NODE_ENV === "production") {
    // IMPORTANTE: Înlocuiește cu URL-ul real al backend-ului tău
    // return process.env.REACT_APP_API_URL || 'https://api.dlc-auto-finance.ro'; // modifica aici cu asta https://api.dlcautocenter.ro
    return "https://api.dlc-auto-finance.ro";
  }
  // Dacă ești în development (localhost)
  return "http://localhost:5000";
};

// const API_BASE_URL = getApiUrl();
const API_BASE_URL = "https://api.dlc-auto-finance.ro";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log("🔄 Attempting login to:", `${API_BASE_URL}/api/auth/login`);
      console.log("🔐 Sending credentials:", formData);
      const response = await fetch(
        `https://api.dlc-auto-finance.ro/api/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            username: formData.username,
            password: formData.password,
          }),
        }
      );

      // Verifică dacă răspunsul este OK
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("✅ Login response:", data);

      if (data.success) {
        // Salvează token-ul în localStorage
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminUser", JSON.stringify(data.admin));

        console.log("✅ Login successful, redirecting to dashboard...");

        // Redirect la dashboard
        navigate("/admin/dashboard");
      } else {
        setError(data.message || "Autentificare eșuată");
      }
    } catch (err) {
      console.error("❌ Login error:", err);

      // Mesaje de eroare mai detaliate
      if (err.message.includes("Failed to fetch")) {
        setError(
          "Nu se poate conecta la server. Verifică dacă backend-ul rulează."
        );
      } else if (err.message.includes("NetworkError")) {
        setError("Eroare de rețea. Verifică conexiunea la internet.");
      } else if (err.message.includes("CORS")) {
        setError("Eroare CORS. Contactează administratorul.");
      } else {
        setError("Eroare la conectare. Încearcă din nou.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-wrapper">
        <div className="admin-login-card">
          <div className="login-header">
            <div className="login-icon">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L2 7v10c0 5.55 3.84 10.74 10 12 6.16-1.26 10-6.45 10-12V7l-10-5z"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <circle
                  cx="12"
                  cy="10"
                  r="3"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M7 18c0-1.66 2.24-3 5-3s5 1.34 5 3"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <h1>Admin Login</h1>
            <p>Acces panel administrare</p>
          </div>

          {error && (
            <div className="login-error">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M12 8v4M12 16h.01"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="username">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="7"
                    r="4"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                </svg>
                Username
              </label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Introdu username-ul"
                required
                autoComplete="username"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <rect
                    x="3"
                    y="11"
                    width="18"
                    height="11"
                    rx="2"
                    ry="2"
                    stroke="currentColor"
                    strokeWidth="2"
                  />
                  <path
                    d="M7 11V7a5 5 0 0110 0v4"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Parolă
              </label>
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Introdu parola"
                required
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? (
                <>
                  <div className="btn-spinner"></div>
                  Se autentifică...
                </>
              ) : (
                <>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Autentifică-te
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <button onClick={() => navigate("/")} className="back-to-site">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M19 12H5M5 12l7 7M5 12l7-7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Înapoi la site
            </button>
          </div>

          <div className="login-info">
            <p>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M12 16v-4M12 8h.01"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
              Doar administratorii au acces la acest panel
            </p>
          </div>

          {/* Debug info - remove in production */}
          {process.env.NODE_ENV === "development" && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                background: "#f0f0f0",
                borderRadius: "8px",
                fontSize: "12px",
                color: "#666",
              }}
            >
              <strong>Debug Info:</strong>
              <br />
              API URL: {API_BASE_URL}
              <br />
              Environment: {process.env.NODE_ENV || "development"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
